<template>
  <div class="g-title">
    <!-- <img class="g-img" :src="url" alt="" /> -->
    <div class="g-img" :class="bg"></div>
    <span class="title"><slot></slot></span>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: "df"
    }
  }
};
</script>

<style lang="stylus" scoped>
.g-title
    height 39px
    width 100%
    background url('~images/granary/title-bg.png') no-repeat top center
    background-size 100% 100%
    color #00FFFF
    .g-img
        width 22px
        height 22px
        display inline-block
        vertical-align middle
        margin-left 10px
    .df
        background url('~images/granary/title/df.png') no-repeat
        background-size 100% 100%
    .green
        background url('~images/granary/title/greed.png') no-repeat
        background-size 100% 100%
    .pp
        background url('~images/granary/title/pp.png') no-repeat
        background-size 100% 100%
    .cyfb
        background url('~images/granary/title/cyfb.png') no-repeat
        background-size 100% 100%
    .czqs
        background url('~images/granary/title/czqs.png') no-repeat
        background-size 100% 100%
    .scl
        background url('~images/granary/title/scl.png') no-repeat
        background-size 100% 100%
    .title
        padding-left 10px
        line-height 39px
        font-size 15px
        font-weight 600
</style>
